
















import { Vue, Component } from "vue-property-decorator";
import SideBar from "@/components/SideBar.vue";
import AppBar from "@/components/AppBar.vue";

@Component({
  components: {
    SideBar,
    AppBar
  }
})
export default class Home extends Vue {
  get isHomePage() {
    return this.$route.name === "Home";
  }
}
